/**
 * Doctor UI: patient name + optional "Booked by UserName (Relation)" for family bookings.
 */
export function DoctorPatientInfo({ appointment, titleClass = 'fw-bold mb-0', subtitleClass = 'text-muted small mb-0' }) {
  if (!appointment) return null;

  return (
    <>
      <h6 className={titleClass}>{appointment.patient_name}</h6>
      {appointment.booked_by_display ? (
        <p className={subtitleClass}>
          <i className="bi bi-person-badge me-1" aria-hidden="true" />
          Booked by {appointment.booked_by_display}
          {appointment.patient_email ? (
            <span className="d-block mt-1">{appointment.patient_email}</span>
          ) : null}
        </p>
      ) : (
        <p className={subtitleClass}>{appointment.patient_email}</p>
      )}
    </>
  );
}

export default DoctorPatientInfo;
